import React from 'react';
import ReactDOM from 'react-dom/client';
import "./css/typography.css";
import "./css/colours.css";
import "./css/page-header.css";
import "./css/flex.css";
import "./css/modifiers.css";
import "./css/layout.css";
import "./css/main-banner.css";
import "./css/fonts.css";
import "./css/nav.css";
import "./css/material-icons.css";
import "./css/blade.css";
import "./css/content-article.css";
import "./css/elements.css";
import "./css/responsive.css";
import "./css/carousel.css";
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
